import { AuthContainer } from 'containers/auth/AuthContainer';
import { ProcoreAuthTokenExchangeContainer } from 'containers/auth/ProcoreAuthTokenExchangeContainer';

const name = 'AuthContainer';

export { name, AuthContainer, ProcoreAuthTokenExchangeContainer };
